import { render, staticRenderFns } from "./proxyOverTimeLeaveQuery.vue?vue&type=template&id=352ab860&scoped=true&"
import script from "./proxyOverTimeLeaveQuery.vue?vue&type=script&lang=js&"
export * from "./proxyOverTimeLeaveQuery.vue?vue&type=script&lang=js&"
import style0 from "./proxyOverTimeLeaveQuery.vue?vue&type=style&index=0&id=352ab860&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352ab860",
  null
  
)

export default component.exports